import { BMC_BLOCKS, BMC_STAGES } from '../common_components/bmc/bmc_constants';

const BUSINESS_ROUTES = [
  "igbusiness",
  "memberships/igbusiness",
  "dashboards/business/igbusiness",
  "dashboards/product/igbusiness",
  "customers/igbusiness",
]

const BUSINESS_ROUTE_PATH = `/:locale(es|en)?/(${BUSINESS_ROUTES.join("|")})`;

const LEAN_BLOCKS = {
  MEASURE: 'measure',
  LEARN: 'learn',
  BUILD: 'build',
};

const BOARD_TYPES = {
  CURRENT_BMC: 'current_bmc',
  VISION: 'vision',
};

const TEMPLATES = {
  [BMC_STAGES.OBSERVATIONAL]: {
    0: {
      [BMC_BLOCKS.KEY_PROPOSITIONS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.CHANNELS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.REVENUE_STREAMS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.COST_STRUCTURE]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_PARTNERS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_ACTIVITIES]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_RESOURCES]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.CUSTOMER_SEGMENTS]: { automatic: false, cards: 1 },
      [LEAN_BLOCKS.MEASURE]: { automatic: false, cards: 3 },
      [LEAN_BLOCKS.BUILD]: { automatic: false, cards: 0 },
      [LEAN_BLOCKS.LEARN]: { automatic: false, cards: 0 },
    },
  },

  [BMC_STAGES.FIRST_USER]: {
    0: {
      [BMC_BLOCKS.KEY_PROPOSITIONS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.CHANNELS]: { automatic: false, cards: 2 },
      [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.REVENUE_STREAMS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.COST_STRUCTURE]: { automatic: false, cards: 2 },
      [BMC_BLOCKS.KEY_PARTNERS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_ACTIVITIES]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_RESOURCES]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.CUSTOMER_SEGMENTS]: { automatic: true, cards: 0 },
      [LEAN_BLOCKS.MEASURE]: { automatic: false, cards: 3 },
      [LEAN_BLOCKS.BUILD]: { automatic: false, cards: 0 },
      [LEAN_BLOCKS.LEARN]: { automatic: false, cards: 0 },
    },
  },

  [BMC_STAGES.FIRST_GROUP]: {
    0: {
      [BMC_BLOCKS.KEY_PROPOSITIONS]: { automatic: true, cards: 0 },
      [BMC_BLOCKS.CHANNELS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.REVENUE_STREAMS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.COST_STRUCTURE]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_PARTNERS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_ACTIVITIES]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_RESOURCES]: { automatic: false, cards: 2 },
      [BMC_BLOCKS.CUSTOMER_SEGMENTS]: { automatic: true, cards: 0 },
      [LEAN_BLOCKS.MEASURE]: { automatic: false, cards: 3 },
      [LEAN_BLOCKS.BUILD]: { automatic: false, cards: 0 },
      [LEAN_BLOCKS.LEARN]: { automatic: false, cards: 0 },
    },
  },

  [BMC_STAGES.FOCUS_GROUP]: {
    0: {
      [BMC_BLOCKS.KEY_PROPOSITIONS]: { automatic: true, cards: 0 },
      [BMC_BLOCKS.CHANNELS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.REVENUE_STREAMS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.COST_STRUCTURE]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_PARTNERS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_ACTIVITIES]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_RESOURCES]: { automatic: false, cards: 4 },
      [BMC_BLOCKS.CUSTOMER_SEGMENTS]: { automatic: true, cards: 0 },
      [LEAN_BLOCKS.MEASURE]: { automatic: false, cards: 2 },
      [LEAN_BLOCKS.BUILD]: { automatic: false, cards: 0 },
      [LEAN_BLOCKS.LEARN]: { automatic: false, cards: 0 },
    },
  },

  [BMC_STAGES.KNOW_HOW]: {
    0: {
      [BMC_BLOCKS.KEY_PROPOSITIONS]: { automatic: true, cards: 0 },
      [BMC_BLOCKS.CHANNELS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.REVENUE_STREAMS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.COST_STRUCTURE]: { automatic: false, cards: 2 },
      [BMC_BLOCKS.KEY_PARTNERS]: { automatic: false, cards: 2 },
      [BMC_BLOCKS.KEY_ACTIVITIES]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_RESOURCES]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.CUSTOMER_SEGMENTS]: { automatic: true, cards: 0 },
      [LEAN_BLOCKS.MEASURE]: { automatic: false, cards: 3 },
      [LEAN_BLOCKS.BUILD]: { automatic: false, cards: 0 },
      [LEAN_BLOCKS.LEARN]: { automatic: false, cards: 0 },
    },
  },

  [BMC_STAGES.EARLY_ADOPTERS]: {
    0: {
      [BMC_BLOCKS.KEY_PROPOSITIONS]: { automatic: true, cards: 0 },
      [BMC_BLOCKS.CHANNELS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.REVENUE_STREAMS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.COST_STRUCTURE]: { automatic: false, cards: 4 },
      [BMC_BLOCKS.KEY_PARTNERS]: { automatic: false, cards: 2 },
      [BMC_BLOCKS.KEY_ACTIVITIES]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_RESOURCES]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.CUSTOMER_SEGMENTS]: { automatic: true, cards: 0 },
      [LEAN_BLOCKS.MEASURE]: { automatic: false, cards: 3 },
      [LEAN_BLOCKS.BUILD]: { automatic: false, cards: 0 },
      [LEAN_BLOCKS.LEARN]: { automatic: false, cards: 0 },
    },
  },

  [BMC_STAGES.FIRST_CLIENT]: {
    0: {
      [BMC_BLOCKS.KEY_PROPOSITIONS]: { automatic: true, cards: 0 },
      [BMC_BLOCKS.CHANNELS]: { automatic: false, cards: 5 },
      [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.REVENUE_STREAMS]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.COST_STRUCTURE]: { automatic: false, cards: 2 },
      [BMC_BLOCKS.KEY_PARTNERS]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_ACTIVITIES]: { automatic: false, cards: 1 },
      [BMC_BLOCKS.KEY_RESOURCES]: { automatic: false, cards: 3 },
      [BMC_BLOCKS.CUSTOMER_SEGMENTS]: { automatic: true, cards: 0 },
      [LEAN_BLOCKS.MEASURE]: { automatic: false, cards: 3 },
      [LEAN_BLOCKS.BUILD]: { automatic: false, cards: 0 },
      [LEAN_BLOCKS.LEARN]: { automatic: false, cards: 0 },
    },
  },

  [BMC_STAGES.FREE]: {},
};

export {
  LEAN_BLOCKS, BOARD_TYPES, TEMPLATES, BUSINESS_ROUTE_PATH,
};
